import React from 'react';
import styled from 'styled-components';

function Footer() {

const Wrapper = styled.footer`
    
    color: white;
    width: 100%;
    padding: 50px;
 
    text-align: center;
    position: relative;  
    z-index: 10;  
  `;


    return (
        <Wrapper>
            © The Won Food Inc.
        </Wrapper>
    );


    }

    export default Footer;
    